import React from 'react';
import { storyData } from '../data/mockData';

const Story = () => {
  // Collage images for food, restaurants, beauty clinics
  const collageImages = [
    {
      src: "https://images.unsplash.com/photo-1600891964599-f61ba0e24092?w=600&q=80",
      alt: "Gourmet food photography",
      className: "col-span-2 row-span-2"
    },
    {
      src: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=400&q=80",
      alt: "Restaurant interior",
      className: "col-span-1 row-span-1"
    },
    {
      src: "https://images.unsplash.com/photo-1552693673-1bf958298935?w=400&q=80",
      alt: "Beauty clinic treatment",
      className: "col-span-1 row-span-1"
    },
    {
      src: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=400&q=80",
      alt: "Fine dining presentation",
      className: "col-span-1 row-span-1"
    },
    {
      src: "https://images.unsplash.com/photo-1538333581680-29dd4752ddf2?w=400&q=80",
      alt: "Café interior design",
      className: "col-span-1 row-span-1"
    },
    {
      src: "https://images.unsplash.com/photo-1596740926849-2d473dee8d60?w=400&q=80",
      alt: "Beauty clinic interior",
      className: "col-span-2 row-span-1"
    }
  ];

  return (
    <section className="section-padding bg-[#0a0a0a]">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Content */}
          <div className="order-2 lg:order-1">
            <span className="inline-block text-sm font-medium text-[#c9a962] tracking-wider uppercase mb-4">
              My Journey
            </span>
            
            <h2 className="heading-1 text-white mb-8">
              {storyData.title}
            </h2>
            
            <div className="space-y-5">
              {storyData.paragraphs.map((paragraph, index) => (
                <p key={index} className="body-large text-[#b3b3b3]">
                  {paragraph}
                </p>
              ))}
            </div>
          </div>
          
          {/* Image Collage */}
          <div className="order-1 lg:order-2">
            <div className="relative">
              {/* Collage Grid */}
              <div className="grid grid-cols-4 grid-rows-3 gap-3 aspect-square">
                {collageImages.map((image, index) => (
                  <div 
                    key={index}
                    className={`overflow-hidden border border-[#2a2a2a] image-hover ${image.className}`}
                  >
                    <img 
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover"
                    />
                  </div>
                ))}
              </div>
              
              {/* Decorative quote */}
              <div className="absolute -bottom-6 -right-6 bg-[#c9a962] text-[#0a0a0a] p-6 max-w-[200px] hidden lg:block z-10">
                <p className="text-sm font-medium italic">
                  "Real experience, real results, real brands."
                </p>
              </div>
              
              {/* Decorative border */}
              <div className="absolute -top-4 -left-4 w-20 h-20 border border-[#c9a962]/30 -z-10 hidden lg:block" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Story;
